import React from 'react';
import FooterButton from './FooterButton';

const SubmitButton = ({
  processing,
  valid,
  acknowledged,
  exceedsMaxDocuments,
}: {
  processing: boolean;
  valid: boolean;
  acknowledged: boolean;
  exceedsMaxDocuments: boolean;
}) => {
  const disabled = processing || !valid || !acknowledged || exceedsMaxDocuments;

  return (
    <FooterButton
      kind='primary'
      type='submit'
      value='buttons.send'
      testId='candidate-story-footer-submit-button'
      processing={processing}
      disabled={disabled}
    />
  );
};

export default SubmitButton;
